import * as React from "react";
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { normalize } from "styled-normalize";

import theme from "./theme";
import { typeScale } from "./themeUtils";

const GlobalStyle = createGlobalStyle`
  ${normalize}
  html {
    ${typeScale.md}
    height: 100%;
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    height: 100%;
    overflow: auto;
    min-width: 48rem;
    min-height: 100vh;
    margin: 0;
    background-color: #f8f8f8;
    color: ${(props) => props.theme.colours.body};
    font-family: "Mulish", -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1,h2 {
    margin: 0 0 1rem 0;
  }
  h3,h4,h5 {
    margin: 0 0 0.5rem 0;
  }
  
  li {
      padding: 0;
      margin: 0;
  }
  address {
    font-style: normal;
  }
  p {
      margin: 0 0 1.5rem 0;
  }
  p:last-child {
      margin: 0;
  }
  a {
      color: ${(props) => props.theme.colours.links}   
  }  
  a:focus-visible {
    outline: 0;
  }
  a:focus-visible > div {
    outline-color: transparent;
    box-shadow: 0 0 0 3px ${(props) => props.theme.colours.focus};
  }

  dl {
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
  }

  dd {
    margin-inline-start: 0;
  }
  
  .App {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
  }
`;

const Provider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <>
    <ThemeProvider theme={theme}>
      <GlobalStyle theme={theme} />
      {children}
    </ThemeProvider>
  </>
);

export default Provider;
